import React from 'react';
import { Polyline } from 'react-leaflet';
import { missionPointsCollectionToPolyline } from 'utils/parsingUtils';

export const OrdersMapElement = props => {
  return props.orders?.map(order => {
    const missionRoute =
      order.missionRoute &&
      missionPointsCollectionToPolyline(JSON.parse(order.missionRoute));
    if (!missionRoute) return null;
    return (
      <Polyline
        color={'orange'}
        positions={missionRoute}
        weight={2}
        opacity={0.8}
      />
    );
  });
};
